import { Component, OnInit, Input } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import { Theme } from 'src/app/models/theme';

@Component({
  selector: 'currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements OnInit {
  @Input() currency: string;

  currentTheme = Theme.Light;

  constructor(private themeService: ThemeService) { }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
  }
}
